import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CommonComponentsModule } from '@views/common/components/common-components.module';
import { LayoutPageComponent } from '@vueling-ng/vy-ds/src/lib/components/layouts/layout-page';
import { AlertBannerModule } from 'app/shared/alerts';
import { PageLayoutComponent } from './page-layout.component';

@NgModule({
  imports: [LayoutPageComponent, CommonComponentsModule, CommonModule, RouterOutlet, AlertBannerModule],
  declarations: [PageLayoutComponent]
})
export class PageLayoutModule {}
